import defaultLayout from './../../../layouts/default/default.vue'
import paginationComponent from './../../../components/pagination/pagination.vue'
import hofService from './../../../services/hof'
import teamsService from './../../../services/teams'
import store from './../../../store'
import {includes, filter} from 'lodash'

export default {
  components: {
    VLayout: defaultLayout,
    Pagination: paginationComponent,
  },

  created () {
    hofService.find()
    if (this.nbResults) {
      this.filtersAreOpen = false
    }
    store.dispatch('fetchSports')
    store.dispatch('setPage', {title: 'Our Teams'})
  },

  data () {
    return {
      sports: [],
      genders: [],
      genderList: [
        {value: 'Boys', text: 'Boys'},
        {value: 'Girls', text: 'Girls'},
        {value: 'Coed', text: 'Coed'},
      ],
      filtersAreOpen: true,
      decade: 'all',
      year: 0,
      perPage: 15,
    }
  },

  methods: {
    getFilters () {
      return {
        year: this.year,
        decade: this.year === 0 ? this.decade : 0,
        sport: this.sports,
        gender: this.genders,
      }
    },
    search () {
      const filters = this.getFilters()
      teamsService.find(filters)
      this.filtersAreOpen = false
      store.commit('pagination/PAGINATE', 1)
    },
    cancel () {
      this.filtersAreOpen = false
    },
    isInHallOfFame (team) {
      return !team.hallOfFame && includes(store.state.hof.all.teams, team.teamName)
    },
  },

  computed: {
    years () {
      if (this.decade === 'all') {
        return false
      }
      const currentYear = new Date().getFullYear()
      let years = [{text: `All ${this.decade}'s years`, value: 0}]
      for (let year = +this.decade; year < (+this.decade + 10); year++) {
        if (year <= currentYear) {
          years.push({text: year, value: year})
        }
      }
      this.year = 0
      return years
    },
    nbResults () {
      return this.teamList.length || 0
    },
    currentPage () {
      const pagination = store.state.pagination || {page: 1}
      return pagination.page
    },
    teamsPaginated () {
      const index = (this.currentPage - 1) * this.perPage
      if (this.nbResults) {
        return this.teamList.slice(index, index + this.perPage)
      }
    },
    resultsShown () {
      const firstResult = (((this.currentPage - 1) * this.perPage) + 1)
      const lastResult = (firstResult + this.perPage - 1)
      return firstResult + '-' + lastResult
    },
    teamList () {
      return store.state.teams.teams || []
    },
    sportList () {
      const exclude_sports = ['winter_track_and_field', 'General'];
      return filter((store.state.sports.all || []), s => !includes(exclude_sports, s.value))
    }
  },
}
